
    import "src/shared/components/BeatsInfoSlider/index.module.scss?farm_css_modules";
    
    export default {"main": `main-9b6bd25f`,"open": `open-9b6bd25f`,"paddedRow": `paddedRow-9b6bd25f`,"retailerContainer": `retailerContainer-9b6bd25f`,"row1": `row1-9b6bd25f`}
    